import { writable } from 'svelte/store'

export function create (data) {
  if (!data) {
    return writable()
  }

  return writable(JSON.parse(JSON.stringify(data)))
}
